import React from "react";
import SecondaryTabs from "../../components/SecondaryTabs";
import OnlineServiceTab from "../influencer/OnlineServiceTab";
import InPersonServiceTab from "../influencer/InPersonServiceTab";

const ScheduleTab = () => {
  const tabsInfo = [
    {
      value: "online",
      text: "Online",
      TapPanelContent: OnlineServiceTab,
    },
    {
      value: "in-person",
      text: "In-person",
      TapPanelContent: InPersonServiceTab,
    },
  ];
  return (
    <div>
      <SecondaryTabs tabsInfo={tabsInfo} />
    </div>
  );
};

export default ScheduleTab;
